// extracted by mini-css-extract-plugin
export var btn = "MediaLogoSection-module--btn--51509";
export var left = "MediaLogoSection-module--left--d5534";
export var logoWrapper = "MediaLogoSection-module--logoWrapper--ffcde";
export var logos = "MediaLogoSection-module--logos--d0e0f";
export var mediaContainer = "MediaLogoSection-module--mediaContainer--a8974";
export var right = "MediaLogoSection-module--right--8fd28";